import { render } from "./MainStat2023.vue?vue&type=template&id=6c950fbc"
import script from "./MainStat2023.vue?vue&type=script&lang=js"
export * from "./MainStat2023.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__